import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How fast can you deploy emergency backup staff?",
    a: "Our rapid dispatch protocol gets vetted crew to your venue in under 3 hours in our core metro markets. Every booking also carries a 15% standby reserve roster, so most gaps are filled before doors open.",
  },
  {
    q: "What uniforms do your staff wear?",
    a: "Our standard kit is an all-black tactical uniform with visible STAFF badging and RFID credentials. For VIP and brand activation roles we can match your dress code or wear client-branded apparel you provide.",
  },
  {
    q: "Are your workers employees or contractors?",
    a: "Every Sora crew member is employed directly by us. We handle payroll tax, superannuation, workers comp, and liability — so none of that risk or paperwork ever reaches your team.",
  },
  {
    q: "What happens if someone calls in sick?",
    a: "Your dedicated onsite captain activates the standby reserve immediately. Our zero no-show guarantee means every confirmed post is filled — the swap happens behind the scenes.",
  },
  {
    q: "Do you handle multi-day festivals across several venues?",
    a: "Yes. We run multi-day, multi-venue deployments with dedicated captains per zone, centralized check-in telemetry, and one consolidated invoice at the end of the run.",
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-[#0F111A] border-t border-white/10">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-xs uppercase tracking-[0.2em] font-mono-tactical font-semibold text-sky-400">
            Organizer FAQs
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
            Questions Event Directors Ask Us
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="mt-10">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-accordion-item-${i + 1}`}
              className="border-white/10"
            >
              <AccordionTrigger className="text-left text-white hover:text-sky-400 font-semibold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
